import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { FaInfoCircle } from 'react-icons/fa'

interface DonorTypeSectionProps {
  donorType?: string
  donorId: string
}

const DonorTypeSection: React.FC<DonorTypeSectionProps> = ({ donorType, donorId }) => {
  const hasTooltip = donorType === 'No ID Release' || donorType === 'ID Release'

  return (
    <div className="donor-card__type-section">
      <span className="donor-type__label">
        Tipo de Doador
        {hasTooltip && (
          <OverlayTrigger
            placement="bottom"
            overlay={(
              <Tooltip id={`tooltip-donor-type-${donorId}`}>
                <div style={{ textAlign: 'left', padding: '8px' }}>
                  <p className="font-weight-bold mb-2">{donorType}</p>
                  {donorType === 'No ID Release' && (
                    <p className="font-sm mb-0">
                      Por lei ou por opção os doadores anônimos não deram autorização para compartilhar sua identidade com a criança, e nenhum contato poderá ser estabelecido entre eles. Doadores anônimos dispõem da <b>mesma quantidade e qualidade de informações nos perfis dos catálogos.</b>
                    </p>
                  )}
                  {donorType === 'ID Release' && (
                    <p className="font-sm mb-0">
                      Cada banco internacional tem o seu conceito de doador ID Aberto:<br />
                      SSB: o doador concordou em ter pelo menos uma forma de contato com a criança nascida de sua doação quando a criança completar 18 anos.<br />
                      ESB: doadores que deram permissão para que alguns dados da sua identidade fossem revelados à criança quando ela atingir a maioridade, 18 anos.<br />
                      Somente a criança poderá obter as informações do doador através do banco de sêmen de onde a amostra foi importada.<br />
                      <br />
                      <b>Importante:</b> Apesar de nos permitirem importar doadores de ID Aberto, o entendimento atual da ANVISA não libera a revelação da identidade dos doadores Open ID. Mas até a futura criança completar 18 anos isso pode mudar!
                    </p>
                  )}
                </div>
              </Tooltip>
            )}
          >
            <span className="donor-type__info-icon" role="button" tabIndex={0}>
              <FaInfoCircle />
            </span>
          </OverlayTrigger>
        )}
      </span>
      <span className="donor-type__value">{donorType || 'Anônimo'}</span>
    </div>
  )
}

export default DonorTypeSection
